import './style.css';

(function(){
  if (!window.SIMPLE_POPIN_SETTINGS) return;
  const S = window.SIMPLE_POPIN_SETTINGS;
  if (!S.enabled) return;

  const cookieName = `simple_popin_seen_${S.version || 'v1'}`;

  const setCookie = (name, days) => {
    const d = new Date();
    d.setTime(d.getTime() + (days*24*60*60*1000));
    document.cookie = `${name}=1; expires=${d.toUTCString()}; path=/; SameSite=Lax`;
  };
  const getCookie = (name) => {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\/+^])/g, '\\$1') + '=([^;]*)'));
    return match ? match[1] : null;
  };

  if (getCookie(cookieName)) return;

  const qs = (s) => document.querySelector(s);
  const backdrop = qs('#simple-popin-backdrop');
  const popin = qs('#simple-popin');
  if (!backdrop || !popin) return;
  const closeBtn = popin.querySelector('.simple-popin__close');

  let lastFocused = null;
  const focusableSelector = 'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

  const open = () => {
    lastFocused = document.activeElement;
    backdrop.hidden = false;
    popin.hidden = false;
    document.documentElement.classList.add('simple-popin-open');
    document.body.style.overflow = 'hidden';

    const focusables = popin.querySelectorAll(focusableSelector);
    if (focusables.length) (focusables[0]).focus();
    else if (closeBtn) closeBtn.focus();
  };

  const close = () => {
    backdrop.hidden = true;
    popin.hidden = true;
    document.body.style.overflow = '';
    document.documentElement.classList.remove('simple-popin-open');
    if (lastFocused && lastFocused.focus) lastFocused.focus();
    setCookie(cookieName, 10);
  };

  popin.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'Tab') {
      const list = Array.from(popin.querySelectorAll(focusableSelector)).filter(el => (el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement));
      if (!list.length) return;
      const first = list[0];
      const last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });
  if (closeBtn) closeBtn.addEventListener('click', (e) => { e.preventDefault(); close(); });
  backdrop.addEventListener('click', () => close());
  popin.addEventListener('click', (e) => {
    if (!e.target.closest('.simple-popin__inner')) close();
  });

  const delay = Math.max(0, parseInt(S.delay || 0, 10));
  window.setTimeout(open, delay);
})();
